import debug from "debug";
import { getConfig } from "@jti/fe-common";
const log = debug("desjti:newRelic:noticeError");
export function addRelease(releaseName, releaseId) {
    if (window.newrelic) {
        window.newrelic.addRelease(releaseName, releaseId);
    }
}
export function noticeError(error, customParams) {
    if (window.newrelic && getConfig().NEW_RELIC_NOTICE_ERROR === "true") {
        window.newrelic.noticeError(error, customParams);
    }
    log(`[${error.name}]${error.message}`, customParams);
}
//# sourceMappingURL=newRelic.js.map